import React from 'react';
import Footer from '../services/Footer';

const Error404 = () => {
  return (
    <div className="flex flex-col min-h-screen"> {/* Cambiado a min-h-screen */}
      <div className="flex flex-col justify-center items-center flex-grow"> {/* Agregado flex-grow */}
        <h1 className="text-5xl font-bold">404</h1>
        <p className="text-xl">Página no encontrada</p>
      </div>
      <Footer />
    </div>
  );
}

export default Error404;
